// Vue & Plugins
import {MaybeRefOrGetter, Ref, toValue} from 'vue'

// Composables
import { useInfiniteQuery } from '@tanstack/vue-query'

// Models
import { SiteID} from '../../sites/models/site'

// Services
import {fetch} from '../shiftReasonService'

export function useShiftReasonQueryInfinite(siteId: MaybeRefOrGetter<SiteID>, name: Ref<string>) {
    return useInfiniteQuery({
        queryKey: ['shift-reason-infinite', { siteId, name }],
        queryFn: async ({ pageParam }) => await fetch(toValue(siteId), name.value, 15, pageParam),
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            const nextPage = lastPage.pagination.currentPage + 1

            if (nextPage > lastPage.pagination.totalPages) {
                return undefined
            }

            return nextPage
        },
    })
}
